import { render, staticRenderFns } from "./DomainLayout.vue?vue&type=template&id=dbaa7b54&"
import script from "./DomainLayout.vue?vue&type=script&lang=js&"
export * from "./DomainLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbaa7b54')) {
      api.createRecord('dbaa7b54', component.options)
    } else {
      api.reload('dbaa7b54', component.options)
    }
    module.hot.accept("./DomainLayout.vue?vue&type=template&id=dbaa7b54&", function () {
      api.rerender('dbaa7b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/domains/DomainLayout.vue"
export default component.exports